import React from 'react';
import { Stack, Box } from '@mui/material';
import { StyledDataGrid, StyledCard, StyledCardTitle, DataGridProps, FlexDiv } from '../../../../../custom/components';
import { EditIcon, DeleteIcon, AddIcon, } from '../../../../../custom/constants';
import uldStyles from './uld.module.css';
import styles from '../../../../../custom/style.module.css';
import UldModal from './UldModal';

const Uld = (props) => {
  const columns = [
    {
      field: 'prefix',
      headerName: 'Prefix',
      minWidth: 100,
      flex: 1
    },
    // {
    //   field: 'wgt',
    //   headerName: 'Weight',
    //   minWidth: 100,
    //   flex: 1,
    //   renderCell: ({ value }) => {
    //     return <span>{value} Kg</span>;
    //   }
    // },
    {
      field: 'type',
      headerName: 'Type',
      minWidth: 100,
      flex: 1
    },
    // {
    //   field: 'ac_type',
    //   headerName: 'Aircraft Type',
    //   minWidth: 100,
    //   flex: 1,
    //   renderCell: ({ value }) => {
    //     return (
    //       <span>
    //         {value && value.length > 0 ? value.join(', ') : 'N/A'}
    //       </span>
    //     );
    //   }
    // },
    {
      field: 'action',
      headerName: 'Action',
      align: 'center',
      headerAlign: 'center',
      // minWidth: 100, 
      flex: 1,
      width: 90,
      sortable: false,
      disableColumnMenu: true,
      renderCell: ({ row }) => {
        return (
          <Stack direction='row' spacing={2} justifyContent='center' className={styles.actionIcons}>
            <EditIcon onClick={() => { props.handleOpen('edit', row); }} />
            <DeleteIcon type='button' onClick={(e) => { props.handleDelete(row.id, e.target); }} />
          </Stack>

        );
      }
    },
  ];

  return (
    <div>
      <StyledCard>
        <FlexDiv><StyledCardTitle>ULD Mapping</StyledCardTitle></FlexDiv>
        <Stack direction='row' alignItems={'center'} justifyContent='flex-end' mb={2} mt={'-24px'}>
          <AddIcon className={styles.addIcon} title='Add ULD' onClick={() => props.handleOpen('add')} />
        </Stack>
        <div className={styles.tableWrapper}>
          <Box className={`${styles.tableOuter} ${uldStyles.listTableOuter}`}>
            <StyledDataGrid
              {...DataGridProps}
              rows={props.data}
              columns={columns}
              param={props.data?.length}
            />
          </Box>
        </div>
      </StyledCard>

      <UldModal
        action={props.action}
        uldFields={props.uldFields}
        uldErrors={props.uldErrors}
        onChange={props.onChange}
        addMail={props.addMail}
        editMail={props.editMail}
        uldModal={props.uldModal}
        onClose={props.onClose}
      />
    </div>
  );
};

export default Uld;